import srcollTop from '../assets/new-ui/scroll-top-icon.png'
export default function ScrollTop() {

  function srcollToTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  return (
    <div className='scrollTopContainer' onClick={() => srcollToTop()}>
      <img src={srcollTop} alt='scroll top' />
    </div>
  )
}